/* tslint:disable */
/* eslint-disable */
/**
 * ciselniky Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface PripomienkaValidationResponse
 */
export interface PripomienkaValidationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaValidationResponse
     */
    'zasadnaValidation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaValidationResponse
     */
    'nezasadnaValidation'?: boolean;
}

/**
 * PripomienkaValidateApi - axios parameter creator
 * @export
 */
export const PripomienkaValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate pripomienky of legislativny material
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePripomienky: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('validatePripomienky', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('validatePripomienky', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('validatePripomienky', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/pripomienky/validation`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PripomienkaValidateApi - functional programming interface
 * @export
 */
export const PripomienkaValidateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PripomienkaValidateApiAxiosParamCreator(configuration)
    return {
        /**
         * Validate pripomienky of legislativny material
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePripomienky(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PripomienkaValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePripomienky(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkaValidateApi.validatePripomienky']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PripomienkaValidateApi - factory interface
 * @export
 */
export const PripomienkaValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PripomienkaValidateApiFp(configuration)
    return {
        /**
         * Validate pripomienky of legislativny material
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePripomienky(type: string, year: number, index: number, options?: RawAxiosRequestConfig): AxiosPromise<PripomienkaValidationResponse> {
            return localVarFp.validatePripomienky(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PripomienkaValidateApi - object-oriented interface
 * @export
 * @class PripomienkaValidateApi
 * @extends {BaseAPI}
 */
export class PripomienkaValidateApi extends BaseAPI {
    /**
     * Validate pripomienky of legislativny material
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkaValidateApi
     */
    public validatePripomienky(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return PripomienkaValidateApiFp(this.configuration).validatePripomienky(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SendBezPripomienokApi - axios parameter creator
 * @export
 */
export const SendBezPripomienokApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBezPripomienok: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('sendBezPripomienok', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('sendBezPripomienok', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('sendBezPripomienok', 'index', index)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/odoslat-bez-pripomienok`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SendBezPripomienokApi - functional programming interface
 * @export
 */
export const SendBezPripomienokApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SendBezPripomienokApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBezPripomienok(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBezPripomienok(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SendBezPripomienokApi.sendBezPripomienok']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SendBezPripomienokApi - factory interface
 * @export
 */
export const SendBezPripomienokApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SendBezPripomienokApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBezPripomienok(type: string, year: number, index: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendBezPripomienok(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SendBezPripomienokApi - object-oriented interface
 * @export
 * @class SendBezPripomienokApi
 * @extends {BaseAPI}
 */
export class SendBezPripomienokApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendBezPripomienokApi
     */
    public sendBezPripomienok(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return SendBezPripomienokApiFp(this.configuration).sendBezPripomienok(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



